import { gql, TypedDocumentNode } from "@apollo/client";

import { ManagedEntitiesGroupedByTypesConnection, PageInfo, Stack } from "types/generated";

const SEARCH_MANAGED_ENTITIES_GROUP_BY_TYPES_FRAGMENT = gql`
  fragment SearchManagedEntitiesGroupByTypesFragment on SearchManagedEntitiesGroupedByTypesOutput {
    edges {
      cursor
      node {
        id
        count
        drifted
        updatedAt
      }
    }
    pageInfo {
      endCursor
      startCursor
      hasNextPage
    }
  }
`;

type SearchManagedEntitiesGroupByTypesData = {
  searchManagedEntitiesGroupByTypes: {
    edges: Array<ManagedEntitiesGroupedByTypesConnection>;
    pageInfo: Pick<PageInfo, "endCursor" | "startCursor" | "hasNextPage">;
  };
};

export const SEARCH_MANAGED_ENTITIES_GROUP_BY_TYPES: TypedDocumentNode<SearchManagedEntitiesGroupByTypesData> = gql`
  query SearchManagedEntitiesGroupByTypes($input: SearchInput!) {
    searchManagedEntitiesGroupByTypes(input: $input) {
      ...SearchManagedEntitiesGroupByTypesFragment
    }
  }
  ${SEARCH_MANAGED_ENTITIES_GROUP_BY_TYPES_FRAGMENT}
`;

type SearchStackManagedEntitiesGroupByTypesData = {
  stack: Pick<Stack, "id"> & SearchManagedEntitiesGroupByTypesData;
};

export const SEARCH_STACK_MANAGED_ENTITIES_GROUP_BY_TYPES: TypedDocumentNode<SearchStackManagedEntitiesGroupByTypesData> = gql`
  query SearchStackManagedEntitiesGroupByTypes($stackId: ID!, $input: SearchInput!) {
    stack(id: $stackId) {
      id
      searchManagedEntitiesGroupByTypes(input: $input) {
        ...SearchManagedEntitiesGroupByTypesFragment
      }
    }
  }
  ${SEARCH_MANAGED_ENTITIES_GROUP_BY_TYPES_FRAGMENT}
`;
